<template>
  <v-app>
    <v-main class="justify-center">
      <v-container class="flex-column my-0 py-0">
        <div
          class="header"
          style="font-size: 200%; font-weight: bold; width: 90%"
        >
          How can we help?
        </div>
        <div class="cards d-flex justify-center" style="flex-wrap: wrap">
          <div
            class="category-wrapper"
            v-for="(category, idx) in cat.slice(0, cat.length / 2)"
            :key="idx"
          >
            <v-card
              :href="category.url"
              class="category d-flex my-2"
            >
              <div class="card-contents">
                <v-icon class="icon">{{ category.icon }}</v-icon>
                <div class="card-text">
                  <v-card-title>{{ category.title }}</v-card-title>
                  <v-card-subtitle>{{ category.subtitle }}</v-card-subtitle>
                </div>
              </div>
            </v-card>
          </div>
        </div>
        <div class="cards d-flex justify-center" style="flex-wrap: wrap">
          <div
            class="category-wrapper"
            v-for="(category, idx) in cat.slice(3, cat.length)"
            :key="idx"
          >
            <v-card
              :href="category.url"
              class="category d-flex my-2"
            >
              <div class="card-contents">
                <v-icon class="icon">{{ category.icon }}</v-icon>
                <div class="card-text">
                  <v-card-title>{{ category.title }}</v-card-title>
                  <v-card-subtitle>{{ category.subtitle }}</v-card-subtitle>
                </div>
              </div>
            </v-card>
          </div>
        </div>
      </v-container>
    </v-main>
  </v-app>
</template>
<script>
export default {
  data() {
    return {
      cat: this.categories,
    };
  },
  props: {
    title: String,
    tagline: String,
    categories: Array,
  },
};
</script>
<style scoped>
html,
body {
  background-color: white !important;
}

.card-contents {
  display: flex;
}

.card-text {
  display: flex;
  flex-direction: column;
}

#content {
  display: flex;
  justify-content: center;
}

.v-card:hover {
  text-decoration: none;
}

.cards {
  margin-left: 2vw;
  margin-right: 2vw;
}

.icon {
  font-size: 7rem !important;
  color: rgb(80, 120, 216, 0.85) !important;
  text-shadow: -1px -1px 0 rgba(0, 0, 0, 0.1), 1px -1px 0 rgba(0, 0, 0, 0.1),
    -1px 1px 0 rgba(0, 0, 0, 0.1), 1px 1px 0 rgba(0, 0, 0, 0.1);
}

.category:hover {
  animation-name: hover;
  animation-iteration-count: 1;
  animation-timing-function: ease-out;
  animation-duration: 200ms;
  animation-fill-mode: both;
  cursor: pointer;
  box-shadow: 0 3px 1px -2px rgba(0, 0, 0, 0.2),
    2px 4px 4px 0 rgba(0, 0, 0, 0.14), 0 1px 5px 0 rgba(0, 0, 0, 0.12) !important;
}

.container {
  display: flex;
  justify-content: center;
  margin: 0;
  padding: 0;
  max-width: unset;
}

.category-wrapper {
  display: flex;
  justify-content: center;
}

@keyframes hover {
  0% {
    transform: translate(0);
  }
  100% {
    transform: translate(-1px, -2px);
  }
}

@media (max-width: 960px) {
  .icon {
    font-size: 4rem !important;
  }
  .v-card__title {
    font-size: 130% !important;
  }
  .v_card__subtitle {
    font-size: 0.65rem !important;
  }
}

@media (orientation: portrait) {
  .header {
    margin-left: 9%;
  }
  .icon {
    font-size: 2rem !important;
    justify-content: flex-start !important;
    margin-bottom: 5px !important;
  }
  .category-wrapper {
    max-width: auto;
    width: auto;
    margin: 0;
  }
  .cards {
    flex-direction: column;
    width: 100vw;
  }
  .container {
    width: 100%;
    margin-left: 0;
  }
  .category {
    justify-content: flex-start !important;
    width: 90% !important;
    flex-direction: row !important;
    padding: 20px !important;
    padding-top: 0 !important;
  }
}

@media (orientation: landscape) {
  .v-card {
    padding: 0 !important;
    width: 100%;
  }
  .header {
    margin-left: 5.5%;
  }
  .category-wrapper {
    width: 30%;
    max-width: 300px;
    margin-left: 1vw;
    margin-right: 1vw;
  }
  .cards {
    flex-direction: row;
  }
  .container {
    width: 100%;
    min-width: 200px !important;
  }
  .category {
    padding: 24px;
    justify-content: center !important;
  }
  .card-contents {
    flex-direction: column;
    padding-top: 1rem;
  }
}
</style>
